import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { Table, Card, Button, Space, Popconfirm, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getGenres } from '../../graphql/queries';
import { deleteGenre } from '../../graphql/mutation';
import '../Audios/Audios.css';

const Genres = () => {
  const navigate = useNavigate();

  const { loading, data, refetch } = useQuery(getGenres, {
    fetchPolicy: 'network-only',
  });

  const [deleteGenreMutation, { loading: deleting }] = useMutation(deleteGenre, {
    onCompleted: () => {
      message.success('Genre deleted');
      refetch();
    },
    onError: (error) => {
      message.error(`Failed to delete: ${error.message}`);
    }
  });

  const handleDelete = (id) => {
    deleteGenreMutation({ variables: { id } });
  };

  const columns = [
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      width: 80,
      render: (icon) => <span style={{ fontSize: 24 }}>{icon}</span>
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: 'Prompt',
      dataIndex: 'prompt',
      key: 'prompt',
      ellipsis: true,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 160,
      render: (date) => dayjs(date).format('YYYY-MM-DD HH:mm')
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/genres/${record.id}`);
            }}
          />
          <Popconfirm
            title="Delete this genre?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="text"
              size="small"
              danger
              icon={<DeleteOutlined />}
              loading={deleting}
              onClick={(e) => e.stopPropagation()}
            />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div className="audios-container">
      <div className="audios-header">
        <p className="audios-breadcrumb">Pages / Genres</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 className="audios-title">Genres</h1>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/genres/create')}>
            Add Genre
          </Button>
        </div>
      </div>

      <Card className="audios-card">
        <Table
          columns={columns}
          dataSource={data?.getGenres || []}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 20,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} genres`,
          }}
          onRow={(record) => ({
            onClick: () => navigate(`/genres/${record.id}`),
            style: { cursor: 'pointer' }
          })}
        />
      </Card>
    </div>
  );
};

export default Genres;
